import { useLocation } from 'react-router-dom';
import LogoRow from './LogoRow';
import ChildrenSelector from './ChildrenSelector';
import CourseSelector from './CourseSelector';

export default function Header() {
  const location = useLocation();
  const showCourseSelector = location.pathname === '/';

  return (
    <header className="shrink-0 z-100 bg-white dark:bg-gray-900 border-b border-[#E5E5E5] dark:border-gray-700 transition-colors">
      <LogoRow />
      <ChildrenSelector />
      {showCourseSelector && <CourseSelector />}
    </header>
  );
}
